import * as React from 'react';
import { useEffect, useState } from 'react';
import {
    SET_CART_BEFORE_TO_SEND_SERVER_SINGLE_PRODUCT,
    SET_INVALID_STATUS_CART_BEFORE_TO_SEND_SERVER_SINGLE_PRODUCT,
} from "../../../store/slice/model/Cart";
import { useDispatch } from "react-redux";
import useReduxState from "../../../hooks/useReduxState";
import { useAxiosIndicatorCheck } from "../../../store/hook/useAxiosIndicatorCheck";
import { isArray, isNumber, isString } from "underscore";
import useCheckAuthPermissions from 'src/hooks/component/useCheckAuthPermissions';
import Common from "../../../pages/Cart/Common";
import Helper from "../../../support/Helper";
import DisplayQtyMinQtyMult from "../../Product/DisplayQtyMinQtyMult";
import produceClone from "../../../helper/produceClone";
import Cart from "@system/config/cart";
import { useCartStore } from 'src/hooks/cart';

// DT - 30 March- 9923: PLP/PDP: Qty field showing inappropriate validation error message for valid qty
const QuantityPicker = (props) => {
    const [__check] = useAxiosIndicatorCheck();
    const [_check_p] = useCheckAuthPermissions();
    const dispatch = useDispatch();
    const [tempQuantity, setTempQuantity] = useState(false);
    const [default_force_default_quantity, set_default_force_default_quantity] = useState(0);
    const [isFirstUpdate, setIsFirstUpdate] = useState(true);
    const [inputQuantityInvalidQuantity, setInputQuantityInvalidQuantity] = useState(false);
    const { single_product, backOrderQty, ObsoleteFlag, EndOfLifeFlag, force_default_min_quantity, adjustedQty } = props;
    const { dont_show_invalid_quantity_for_zero_stock = false } = props;
    const { contract_id = '' } = props;
    const { force_default_quantity } = props;
    const { CHECK_CART_RELATED_INVENTORY_VALIDATION } = props;
    const { show_validation_message_Insufficient_Inventory } = props;
    const { dispatch_invalidFlagReduxDispatch } = props;
    const [insufficientInventoryValidationMessage, setInsufficientInventoryValidationMessage] = useState(props.show_validation_message_based_in_input_quantity_Insufficient_Inventory)
    const { is_default_invalid_quantity } = props;
    const { disable_increase_decrease, min_inv_validation } = props;
    const { single_product_inventory } = props;
    const { single_product_pricing_list } = props;
    const [EndOfLifeOFlagFailedFlag_logic_failed_flag, set_EndOfLifeOFlagFailedFlag_logic_failed_flag] = useState(false);
    const [{ CART_DATA_OBJECT }, { }, { SET_CART_DATA_ERROR }] = useCartStore();
    const uniqueId = props.bom_detail_id ? props.bom_detail_id : single_product.ItemNumber
    const [QtyMult] = useReduxState(single_product.QtyMult,
        'single_product__QtyMult' + uniqueId
    );
    const [QtyMin] = useReduxState(single_product.QtyMin,
        'single_product__QtyMin' + uniqueId);
    const [quantityUpdateToCartInput, setQuantityUpdateToCartInput] = useReduxState((force_default_quantity !== undefined && force_default_quantity > 0 ? force_default_quantity : single_product.QtyMin),
        'single_product__QuantityUpdateToCartInput' + uniqueId
    );
    let { invalid_quantity_message_text } = props;
    if (invalid_quantity_message_text === undefined) {
        invalid_quantity_message_text = false;
    }
    if (invalid_quantity_message_text === false) {
        invalid_quantity_message_text = 'Invalid Quantity';
    }
    const isDisplayErrorMessage = () => {
        SET_CART_DATA_ERROR(true);
        return true
    }

    useEffect(() => {
        if (inputQuantityInvalidQuantity) {
            SET_CART_DATA_ERROR(true);
        } else {
            SET_CART_DATA_ERROR(false);
        }
    }, [inputQuantityInvalidQuantity])

    useEffect(() => {
        invalidFlagReduxDispatch(); // add inventory flag 
    }, [EndOfLifeOFlagFailedFlag_logic_failed_flag])


    useEffect(() => {
        async function fetchHere() {
            // EOL flag 
            if (single_product_pricing_list && isArray(single_product_pricing_list) &&
                single_product_pricing_list.length > 0) {
                if (validateInventoryDisplayMessageStatus() === true) {
                    if ((show_validation_message_Insufficient_Inventory !== undefined &&
                        show_validation_message_Insufficient_Inventory === true &&
                        single_product_inventory && single_product_inventory.quantity < 1)) {
                        setInputQuantityInvalidQuantity(Helper.UUID())
                    }
                }
            }
        }

        fetchHere()
    }, [quantityUpdateToCartInput, show_validation_message_Insufficient_Inventory, __check(['PRODUCT_PRICING_API_CALL', 'PRODUCT_INVENTORY_API_CALL']).status])

    const setQuantityWithAction = async (action) => {
        async function fetchHere() {
            if (single_product !== undefined) {
                let QtyMultHere = QtyMult;
                let QtyMin = single_product.QtyMin;
                let q = 0;
                if (action === 'minus') {
                    if (tempQuantity === false && quantityUpdateToCartInput) {
                        q = quantityUpdateToCartInput - QtyMultHere
                    } else {
                        q = tempQuantity - QtyMultHere
                    }

                    // Validate if Qty < Min
                    if (QtyMin > 0 && q < QtyMin) {
                        q = QtyMin;
                    }
                }
                if (action === 'plus') {
                    if (tempQuantity === false && quantityUpdateToCartInput) {
                        q = (quantityUpdateToCartInput > 0 && quantityUpdateToCartInput < QtyMin) ? QtyMin : (quantityUpdateToCartInput + QtyMultHere) // Set Min as default when Qty is Min
                    } else {
                        q = (tempQuantity > 0 && tempQuantity < QtyMin) ? QtyMin : (tempQuantity + QtyMultHere) // Set Min as default when Qty is Min
                    }
                }
                if (q < 1) {
                    q = 0;
                }
                if (q > 0) {
                    await manageTempQuantity(q, 200);
                    setInputQuantityInvalidQuantity(false)
                }
            }
        }

        fetchHere()
    };

    //We will improve the maths in future
    const validateQuantity = () => {
        let res = 0
        if (quantityUpdateToCartInput !== undefined && quantityUpdateToCartInput !== QtyMin) {
            if (QtyMin < QtyMult) {
                if (quantityUpdateToCartInput % QtyMin !== 0)
                    res = 1
            } else {
                if (QtyMin !== undefined && quantityUpdateToCartInput < QtyMin) {
                    res = 1
                }
                if (QtyMult !== undefined && quantityUpdateToCartInput % QtyMult !== 0) {
                    res = 1
                }
            }
        }
        return res === 0 ? true : false
    };

    /**
     * Owner : Pankaj Nihalani
     * Patch : Reset Redux State After Backorder
     * Date  : 09/06/2022
     */
    useEffect(() => {
        if (insufficientInventoryValidationMessage === true && backOrderQty !== undefined &&
            backOrderQty > 0) {
            setInsufficientInventoryValidationMessage(false);
        }
    }, []);

    useEffect(() => {
        async function fetchHere() {
            if (force_default_quantity !== undefined && !is_default_invalid_quantity && isFirstUpdate) {
                setInputQuantityInvalidQuantity(Helper.UUID())
            }
            if (force_default_quantity !== undefined && single_product !== undefined) {
                setQuantityUpdateToCartInput(force_default_quantity);
            }
        }

        fetchHere();
    }, [force_default_quantity]);

    useEffect(() => {
        async function fetchHere() {
            if (force_default_min_quantity === true) {
                setQuantityUpdateToCartInput(single_product.QtyMin);
            }
        }

        fetchHere();
    }, [force_default_min_quantity]);

    useEffect(() => {
        async function fetchHere() {
            if (force_default_quantity !== undefined) {
                set_default_force_default_quantity(force_default_quantity)
            }
        }

        fetchHere();
    }, []);

    useEffect(() => {
        if (isFirstUpdate === false || (isFirstUpdate === false && inputQuantityInvalidQuantity !== false)) {
            invalidFlagReduxDispatch()
        }
        if (isFirstUpdate === true && dispatch_invalidFlagReduxDispatch === true) {
            invalidFlagReduxDispatch()
        }
    }, [inputQuantityInvalidQuantity]);

    useEffect(() => {
        async function fetchHere() {
            if (single_product !== undefined && validateQuantity(quantityUpdateToCartInput)) {
                let single_product_here = JSON.parse(JSON.stringify(single_product));
                single_product_here.quantityUpdateToCart = quantityUpdateToCartInput;
                await manageDispatch(single_product_here);
            }
        }

        fetchHere();
    }, [quantityUpdateToCartInput]);

    //Experimental code to run add to cart in initial page load
    //without QuantityPicker
    useEffect(() => {
        async function fetchHere() {
            if (single_product !== undefined) {
                let single_product_here = JSON.parse(JSON.stringify(single_product));
                single_product_here.quantityUpdateToCart = quantityUpdateToCartInput;
                await manageDispatch(single_product_here);
            }
        }

        fetchHere();
    }, [single_product_inventory]);
    // }, [single_product_inventory]);

    const invalidFlagReduxDispatch = () => {
        let single_product_here = produceClone(single_product);
        dispatch(SET_INVALID_STATUS_CART_BEFORE_TO_SEND_SERVER_SINGLE_PRODUCT({
            CART_DATA: {
                quantityAddToCart: quantityUpdateToCartInput,
                invalid_quantity: inputQuantityInvalidQuantity !== false,
                invalid_inventory: EndOfLifeOFlagFailedFlag_logic_failed_flag,
                product_inventory: single_product_inventory && single_product_inventory.quantity !== undefined ? single_product_inventory : null,
                ...single_product_here
            }
        }));
    }
    const manageTempQuantity = async (tempQuantityFromParam, timeOut = 700) => {
        setIsFirstUpdate(false)
        tempQuantityFromParam = parseInt(tempQuantityFromParam);
        if (isNaN(tempQuantityFromParam)) {
            tempQuantityFromParam = disable_increase_decrease !== undefined && disable_increase_decrease === 'yes' ? '' : 0;
        }
        setTempQuantity(tempQuantityFromParam)
        const delayDebounceFn = setTimeout(async () => {
            if (tempQuantityFromParam !== false) {
                if (props.disable_edit_force_default_quantity !== undefined) {
                    let q_d;
                    if (props.getPlanInputQuantityCallback !== undefined) {
                        props.getPlanInputQuantityCallback(tempQuantityFromParam)
                    }
                    if (tempQuantityFromParam !== 0 && tempQuantityFromParam % QtyMult === 0) {
                        setInputQuantityInvalidQuantity(false);
                        q_d = true;
                    } else if (tempQuantityFromParam < QtyMin) {
                        setInputQuantityInvalidQuantity(Helper.UUID());
                        q_d = false;
                    } else {
                        setQuantityUpdateToCartInput(tempQuantityFromParam)
                        setInputQuantityInvalidQuantity(Helper.UUID());
                        q_d = false;
                    }
                    if (single_product && single_product.QtyMin !== undefined && tempQuantityFromParam < single_product.QtyMin) {
                        setInputQuantityInvalidQuantity(Helper.UUID());
                        q_d = false;
                    }
                    if (q_d === true && props.getPlanInputQuantityValidatedCallback !== undefined) {
                        setQuantityUpdateToCartInput(tempQuantityFromParam) // update qty for manual add part for EOL/Obsolete parts
                        props.getPlanInputQuantityValidatedCallback(tempQuantityFromParam)
                        return;
                    }
                    if (q_d === true && props.getPlanInputQuantityValidatedCallback === undefined) {
                        setQuantityUpdateToCartInput(tempQuantityFromParam)
                        setInputQuantityInvalidQuantity(false);
                    }
                } else {
                    let q_d;
                    if (tempQuantityFromParam < QtyMin) {
                        setInputQuantityInvalidQuantity(Helper.UUID());
                        q_d = true;
                    } else if (tempQuantityFromParam % QtyMult === 0) {
                        setInputQuantityInvalidQuantity(false)
                        q_d = true;
                    } else if (tempQuantityFromParam !== 0 && tempQuantityFromParam % QtyMult === 0) {
                        setInputQuantityInvalidQuantity(false)
                        q_d = true;
                    } else if (tempQuantityFromParam < QtyMin) {
                        setInputQuantityInvalidQuantity(Helper.UUID());
                        q_d = false;
                    } else if (QtyMin < QtyMult && tempQuantityFromParam % QtyMin === 0) { //DT - 30 march 
                        setInputQuantityInvalidQuantity(false)
                        q_d = true;
                    } else {
                        setInputQuantityInvalidQuantity(Helper.UUID());
                        q_d = false;
                    }
                    if (single_product && single_product.QtyMin !== undefined && tempQuantityFromParam < single_product.QtyMin) {
                        setInputQuantityInvalidQuantity(Helper.UUID());
                        q_d = false;
                    }
                    if (q_d === true) {
                        setQuantityUpdateToCartInput(tempQuantityFromParam);
                        setInputQuantityInvalidQuantity(false);
                    }
                }

            }
        }, timeOut);

        return () => clearTimeout(delayDebounceFn)
    }
    const manageDispatch = async (single_product_here) => {
        if (single_product_inventory && single_product_inventory.quantity !== undefined && validateQuantity(quantityUpdateToCartInput)) {
            if (quantityUpdateToCartInput > 0) {
                let quantityUpdateToCartHere = parseFloat(quantityUpdateToCartInput);
                if (single_product.ERPPartNumber !== undefined && quantityUpdateToCartHere > 0) {
                    single_product_here.quantityAddToCart = quantityUpdateToCartInput;
                    single_product_here.invalid_inventory = EndOfLifeOFlagFailedFlag_logic_failed_flag;
                    dispatch(SET_CART_BEFORE_TO_SEND_SERVER_SINGLE_PRODUCT({
                        CART_DATA: single_product_here
                    }));
                }
            }
        }
    };
    const getDisplayStatusOfQuantityPicker = () => {
        return true;
    };
    const getDisableStatusIncrementer = () => {
        if (__check(['CART_OPERATION_API_CALL']).status) {
            return true;
        }
        if (props.readOnly_quantity !== undefined && props.readOnly_quantity === true) {
            return true;
        }
        return (_check_p('PD_VIEW_CART').status === false || _check_p('PDTG_VIEW_CART').status === false);
    };
    const getDisableStatusInput = () => {
        if (__check(['CART_OPERATION_API_CALL']).status) {
            return true;
        }
        if (props.readOnly_quantity !== undefined && props.readOnly_quantity === true) {
            return true;
        }
        return (_check_p('PD_VIEW_CART').status === false || _check_p('PDTG_VIEW_CART').status === false);
    };
    const validateInventoryDisplayMessageStatus = () => {
        if (__check(['CART_API_CALL', 'PRODUCT_INVENTORY_API_CALL']).status) {
            return false;
        }
        if (CHECK_CART_RELATED_INVENTORY_VALIDATION !== undefined && CHECK_CART_RELATED_INVENTORY_VALIDATION === true &&
            single_product.ERPPartNumber) {
            if (new Common().getInventoryOutOfStockFlagByERPPartNumber(CART_DATA_OBJECT, single_product.ERPPartNumber) === true) {
                return true;
            }
        }
        return false;
    }

    const getRedErrorForBorder = () => {
        if (getObsoleteEOLFlag() === true) {
            return true;
        }
        if (getObsoleteEOLFlag() === true) {
            return true;
        }
        // Obsolete parts highlight border 
        if (validateInventoryDisplayMessageStatus() &&
            single_product && (single_product.ObsoleteFlag || single_product.EndOfLifeFlag)) {
            return true;
        }

        // Non EOL Parts
        if (validateInventoryDisplayMessageStatus() && (single_product.ObsoleteFlag === true || single_product.EndOfLifeOFlag === true) === false) {
            return true;
        }
        
        // Price Mismatch
        if(Helper.valueIsNotNull(force_default_quantity) && Helper.valueIsNotNull(adjustedQty) && force_default_quantity < adjustedQty)
        {
            return true;
        }
        return false;
    }

    const getObsoleteEOLFlag = () => {
        if (ObsoleteFlag !== undefined && ObsoleteFlag === false) {
            return true;
        }
        if (inputQuantityInvalidQuantity !== false) {
            return true;
        }
        return false;
    }
    /**
     * Ticket #  : 9615
     * Change #  : When EOL/Obsolete part having more min than inventory so display only invalid qty message
     * Change by : Pankaj
     * Date      : 07 March 2023  
     */
    const validateInvalidQty = () => {
        if (inputQuantityInvalidQuantity !== false && invalid_quantity_message_text !== undefined && invalid_quantity_message_text !== false
            && (dont_show_invalid_quantity_for_zero_stock === true && single_product_inventory.quantity === 0) === false) {
            return true;
        }
        return false;
    }

    /**
     * Ticket #  : 9654
     * Change #  : Dual insufficint inventory message handling for EOL/Obsolete Part 
     * Change by : Pankaj
     * Date      : 06 April 2023
     */
    const validateEOLObsoleteError = (type = '') => {
        if (ObsoleteFlag === undefined || EndOfLifeFlag === undefined) {
            return true;
        }
        if (type === 'OBS' && ObsoleteFlag === false) {
            return false;
        }

        if (type === 'EOL' && EndOfLifeFlag === false) {
            return false;
        }
        return true;
    }

    const updatePickerCartForError = () => {
        if (ObsoleteFlag === false || EndOfLifeFlag === false) {
            props.getPlanInputQuantityValidatedCallback(quantityUpdateToCartInput)
            return false;
        }
        if (min_inv_validation && quantityUpdateToCartInput > single_product_inventory.quantity && single_product.ObsoleteFlag) {
            props.getPlanInputQuantityValidatedCallback(quantityUpdateToCartInput)
            return;
        }
        return true;
    }
    return (
        <>
            {single_product !== undefined && getDisplayStatusOfQuantityPicker() &&
                <>
                    <div className="quantity w-auto clearfix ">
                        <div className={getRedErrorForBorder() ? "quantity-picker error" : "quantity-picker"}>
                            <div className="bs5 input-group flex-nowrap border-0">
                                {!(disable_increase_decrease !== undefined && disable_increase_decrease === 'yes') &&
                                    <span className="bs5 input-group-prepend flex-nowrap">
                                        <button disabled={getDisableStatusIncrementer()} type="button" aria-label="Decrease Quantity"
                                            onClick={async () => {
                                                await setQuantityWithAction('minus');
                                            }}
                                            className="bs5 btn btn-outline-secondary btn-number br-0">
                                            <span className="fa fa-minus" />
                                        </button>
                                    </span>
                                }
                                {default_force_default_quantity > 0 &&
                                    <>
                                        <input disabled={getDisableStatusInput()} type="text"
                                            className="form-control form-control-sm" aria-labelledby="Quantity"
                                            value={tempQuantity === false ? quantityUpdateToCartInput ? quantityUpdateToCartInput : 0 : tempQuantity}
                                            onChange={async (e) => {
                                                let n = parseInt(e.target.value);
                                                if (!isNumber(n)) {
                                                    n = false;
                                                }
                                                if (isNaN(n)) {
                                                    n = false;
                                                }
                                                /**
                                                 * remove different calls when n false due to resolve clear quantity on bom update quantity
                                                 * AUthor: Devanshi Patel
                                                 */
                                                await manageTempQuantity(n)
                                            }}
                                        />
                                    </>
                                }
                                {!(force_default_quantity !== undefined) &&
                                    <>
                                        <input type="text" className="form-control input-number bg-white" aria-labelledby="Quantity"
                                            disabled={getDisableStatusInput()}
                                            placeholder={QtyMin !== undefined ? QtyMin : 0}
                                            value={tempQuantity === false ? quantityUpdateToCartInput ? quantityUpdateToCartInput : 0 : tempQuantity}
                                            onChange={async (e) => {
                                                let n = parseInt(e.target.value);
                                                if (!isNumber(n)) {
                                                    n = false;
                                                }
                                                if (n !== false) {
                                                    await manageTempQuantity(n)
                                                }
                                            }}
                                        />
                                    </>
                                }
                                {!(disable_increase_decrease !== undefined && disable_increase_decrease === 'yes') &&
                                    <span className="bs5 input-group-append flex-nowrap">
                                        <button disabled={getDisableStatusIncrementer()} type="button" aria-label="Increase Quantity"
                                            onClick={async () => {
                                                await setQuantityWithAction('plus');
                                            }}
                                            className="bs5 btn btn-outline-secondary btn-number bl-0">
                                            <span className="fa fa-plus" />
                                        </button>
                                    </span>
                                }
                            </div>
                            {min_inv_validation && (inputQuantityInvalidQuantity !== false && invalid_quantity_message_text !== undefined && invalid_quantity_message_text !== false
                                && (dont_show_invalid_quantity_for_zero_stock === true && single_product_inventory.quantity === 0) === false) &&
                                updatePickerCartForError() &&
                                <span className="mandatory">{(min_inv_validation && single_product.ObsoleteFlag && quantityUpdateToCartInput > single_product_inventory.quantity ? isDisplayErrorMessage() === true && 'Insufficient Inventory custom' : isDisplayErrorMessage() === true && invalid_quantity_message_text)}</span>
                            }
                            {!min_inv_validation && (inputQuantityInvalidQuantity !== false && invalid_quantity_message_text !== undefined && invalid_quantity_message_text !== false
                                && (dont_show_invalid_quantity_for_zero_stock === true && single_product_inventory.quantity === 0) === false) &&
                                <span className="mandatory">{isDisplayErrorMessage() === true && invalid_quantity_message_text}</span>
                            }
                            {validateQuantity(quantityUpdateToCartInput) === false && single_product_inventory.quantity === 0 &&
                                <span className="mandatory">{isDisplayErrorMessage() === true && 'Invalid Quantity'}</span>
                            }

                            {show_validation_message_Insufficient_Inventory !== undefined &&
                                show_validation_message_Insufficient_Inventory === true &&
                                single_product_inventory && single_product_inventory.quantity < 1 &&
                                <>{inputQuantityInvalidQuantity ? <br /> : ''}
                                    <span className="mandatory">{isDisplayErrorMessage() === true && 'Insufficient Inventory'}</span>
                                </>
                            }

                            {validateInventoryDisplayMessageStatus() === true && validateQuantity(quantityUpdateToCartInput) &&
                                <>
                                    {inputQuantityInvalidQuantity ? <br /> : ''}
                                    {(single_product.ObsoleteFlag === true || single_product.EndOfLifeOFlag === true) === false &&
                                        <span className="mandatory">{isDisplayErrorMessage() === true && 'Insufficient Inventory'}</span>
                                    }
                                    {single_product.ObsoleteFlag === true && validateEOLObsoleteError('OBS') &&
                                        <span className="mandatory">{isDisplayErrorMessage() === true && 'Insufficient Inventory'}</span>
                                    }
                                    {single_product.EndOfLifeOFlag === true && validateEOLObsoleteError('EOL') &&
                                        <span className="mandatory">{isDisplayErrorMessage() === true && 'Insufficient Inventory'}</span>
                                    }
                                </>
                            }
                            {EndOfLifeOFlagFailedFlag_logic_failed_flag === true && window.location.pathname.includes(Cart.getCartPagePlainRouteURL()) === false && validateQuantity(quantityUpdateToCartInput) && validateInvalidQty() === false &&
                                <span className="mandatory">{isDisplayErrorMessage() === true && 'Please select the Quantity less than or equal to the Inventory Stock available for the selected part'}</span>
                            }
                        </div>

                        {show_validation_message_Insufficient_Inventory !== undefined &&
                            show_validation_message_Insufficient_Inventory === true &&
                            single_product_inventory && single_product_inventory.quantity < 1 &&
                            <>{inputQuantityInvalidQuantity ? <br /> : ''}
                                <span className="mandatory">{isDisplayErrorMessage() === true && 'Insufficient Inventory'}</span>
                            </>
                        }

                    </div>
                    {props.showDisplayQtyMinQtyMult !== undefined && props.showDisplayQtyMinQtyMult === 'yes' &&
                        <div
                            className="text-start small-text light light-text collapse_minmax">
                            <DisplayQtyMinQtyMult
                                single_product={single_product} />
                        </div>
                    }
                </>
            }
        </>
    );
}

export default QuantityPicker;